import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AskAIMenuContextProvider } from '@/components/organisms/AskAIMenu/AskAIMenuContext';
import { DataLayer } from '@/components/utils/DataLayer';
import { LocationSearchProvider } from '@/components/utils/LocationSearchProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { ClientOnly } from '@/components';
import UTMSessionStorageHandler from '@/components/utils/UTMSessionStorageHandler';
import { useEloquaTracking } from '@/hooks/useEloquaTracking';
const queryClient = new QueryClient();
export const PageContainer = (props) => {
    const { children, language: page_lang, utmParams, analytics, eloquaSiteId } = props;
    const { pageType: page_type, environment, pageSection: page_section, userType: user_type } = analytics || {};
    useEloquaTracking({ eloquaSiteId });
    const customPageviewProps = { page_lang, page_type, environment, page_section, user_type, is_new_site: true };
    return (_jsxs(DataLayer, { additionalParams: customPageviewProps, children: [_jsx(ClientOnly, { children: _jsx(UTMSessionStorageHandler, { utmParams: utmParams }) }), _jsx(NuqsAdapter, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(AskAIMenuContextProvider, { children: _jsx(LocationSearchProvider, { ...props, children: children }) }) }) })] }));
};
